export const Role = {
  Admin: 'ROLE_ADMIN',
  Client: 'ROLE_CLIENT',
  Commercial: 'ROLE_COMMERCIAL'
};
